<template>
  <section id="outgoingCalls">
    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="active"
      :active="active"
      :actualRol="CurrentRole"
      module="queue"
      @dialog:change="eventdialog"
    ></RangeDateDialog>
    <!-- FIN MODAL DE RANGO DE FECHA -->

    <!-- MODAL DETALLES DE LLAMADAS -->
    <v-dialog v-if="detailsTable" scrollable v-model="detailsTable">
      <v-card class="shadow-1">
        <v-data-table
          id="detailsTable"
          dense
          :headers="detailsTableHeader[actualHeader]"
          :items="detailsTableItems"
          :items-per-page="15"
          :loading="isLoading"
          :options.sync="detailsTableOptions"
          :server-items-length="totalDetailsItems"
        >
          <!-- Items for table 2 5 and 6 -->
          <template v-if="[2, 5, 6].includes(actualHeader)" v-slot:[`item.spoken`]="{ item }">
            <span>
              {{ item.spoken | secondsToTimeFormat }}
            </span>
          </template>
          <template v-if="[2, 5, 6].includes(actualHeader)" v-slot:[`item.hang`]="{ item }">
            <span>
              {{ item.hang }}
            </span>
          </template>
          <!-- Items for table 2 and 3 -->
          <template v-if="![1, 7].includes(actualHeader)" v-slot:[`item.numero`]="{ item }">
            <span>{{ item.csr[0].numero }}</span>
          </template>
          <template v-if="![1, 7].includes(actualHeader)" v-slot:[`item.tiempoespera`]="{ item }">
            <span>
              {{ item.tiempoespera | secondsToTimeFormat }}
            </span>
          </template>
          <!-- Items for all -->
          <template v-slot:[`item.fecha`]="{ item }">
            <span>{{ normalizeDate(item.timestamp) }}</span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <span>
              <v-btn class="rounded-lg" @click="showCDR(item)">
                Ver Detalles
              </v-btn>
            </span>
          </template>
        </v-data-table>

        <v-card-actions class="white">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="detailsTable = false"
              >Cerrar</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- FIN MODAL DE DETALLES DE LLAMADAS -->

    <!-- CDR Dialog -->
    <v-dialog v-model="cdrDialog" max-width="1000px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="cdrDialogTableHeaders"
                :items="cdrDialogData"
                class="elevation-0"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:[`item.hour`]="{ item }">
                  <span>{{ item.fecha | getHourFormat }}</span>
                </template>

                <template v-slot:[`item.duracion`]="{ item }">
                  <span>
                    {{ item.duracion | secondsToTimeFormat }}
                  </span>
                </template>

                <template v-slot:[`item.hablado`]="{ item }">
                  <span>
                    {{ item.hablado | secondsToTimeFormat }}
                  </span>
                </template>

                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip color="transparent" small>
                    <v-icon left small :color="getSpanishState(item.estado).color"
                      >{{ getSpanishState(item.estado).icon }}
                    </v-icon>
                    {{ getSpanishState(item.estado).text }}
                  </v-chip>
                </template>

                <template v-slot:[`item.recordingfile`]="{ item }">
                  <div class="pt-2 pb-1" v-if="item.recordingfile">
                    <v-icon>mdi-pLay</v-icon>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <audio controls preload="none" v-on="on" v-bind="attrs">
                          <source :src="generateUrl(item.recordingfile)" type="audio/wav" />
                          <source :src="generateUrl(item.recordingfile, true)" type="audio/mpeg" />
                          <p>
                            Tu navegador no implementa el elemento audio.
                          </p>
                        </audio>
                      </template>
                      <span>{{ item.recordingfile }}</span>
                    </v-tooltip>
                  </div>
                  <span class="caption grey--text" v-else>No disponible</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="cdrDialog = false">
              Cancelar
            </v-btn>
          </v-hover>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openImportDialog"
                v-bind="attrs"
                v-on="on"
                color="info"
                small
                rounded
                fab
              >
                <v-icon>
                  mdi-upload
                </v-icon>
              </v-btn>
            </template>
            <span>Importar</span>
          </v-tooltip>
        </v-col>
        <v-col cols="auto" class="ml-auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success" v-bind="attrs" v-on="on" small rounded fab>
                <v-icon>
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <span>Exportar</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container> -->

    <v-card class="shadow-1 mt-5 mt-md-10">
      <!-- <v-card-text> -->
      <v-tabs dark grow center-active v-model="tab" background-color="secondary lighten-1">
        <v-tab v-for="(item, index) in filteredTabHeaders" :key="index" @click="search(item)">
          <v-slide-x-transition>
            <v-icon left v-if="tab === index">mdi-check-circle-outline</v-icon>
          </v-slide-x-transition>
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in filteredTabHeaders" :key="item">
          <v-card flat>
            <!-- <v-card-text> -->
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-switch
                    class="ml-auto d-flex d-md-none"
                    v-model="activeGraph"
                    inset
                    label="Ver gráficas"
                  ></v-switch>
                </v-col>

                <v-col v-show="!activeGraph" cols="12" md="6">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Nombre
                          </th>
                          <th class="text-right">
                            Valor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in desserts"
                          :key="item.name"
                          :style="item.type ? 'cursor:pointer' : ''"
                          @click="openDetailDialog(item)"
                        >
                          <!-- getCallDetails(item) -->
                          <template v-if="isLoading">
                            <td class="text-right">
                              <v-skeleton-loader type="list-item"></v-skeleton-loader>
                            </td>
                            <td class="text-right">
                              <v-skeleton-loader class="ml-auto" style="width: 20%" type="text"></v-skeleton-loader>
                            </td>
                          </template>
                          <template v-else>
                            <td>
                              {{ item.name }} &nbsp;

                              <v-tooltip
                                top
                                v-if="item.name === 'Llamadas contestadas' || item.name === 'Llamadas abandonadas'"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">mdi-information-slab-circle</v-icon>
                                </template>
                                <span v-if="item.name === 'Llamadas contestadas'">
                                  Antes de 20s:
                                  {{
                                    tooltipInfo[0].contestadas !== 0
                                      ? tooltipInfo[0].contestadas.a + " (" + tooltipInfo[0].contestadas.b + "%)"
                                      : "No posee"
                                  }}
                                </span>
                                <span v-if="item.name === 'Llamadas abandonadas'">
                                  Antes de 8s:
                                  {{
                                    tooltipInfo[1].abandonadas !== 0
                                      ? tooltipInfo[1].abandonadas.a + " (" + tooltipInfo[1].abandonadas.b + "%)"
                                      : "No posee"
                                  }}
                                </span>
                                <!-- <span v-else-if="item.replied">Top tooltip</span>
                              <span v-else-if="item.replied">Top tooltip</span>
                              <span v-else-if="item.replied">Top tooltip</span> -->
                              </v-tooltip>
                            </td>
                            <td class="text-right">
                              {{ item.total }}
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>

                <v-col cols="12" md="6" v-show="activeGraph">
                  <!-- tabs de las graficas -->
                  <v-card outlined>
                    <v-tabs v-model="tabGraph" background-color="transparent" color="primary" grow>
                      <v-tab v-for="item in graph" :key="item">
                        {{ item }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tabGraph">
                      <v-tab-item v-for="chartItem in graph" :key="chartItem">
                        <v-card flat v-if="render">
                          <apexchart
                            ref="chart3Queue"
                            type="donut"
                            :options="optionsDonut"
                            :series="serieDonut"
                            v-if="chartItem === 'Atención'"
                          ></apexchart>

                          <apexchart
                            ref="chart2Queue"
                            type="bar"
                            :options="optionsBar"
                            :series="serieBar"
                            v-if="chartItem === 'Agentes' && render"
                          ></apexchart>

                          <apexchart
                            ref="chart1Queue"
                            type="line"
                            :options="optionsLine"
                            :series="serieLine"
                            v-if="chartItem === 'Tiempo' && render"
                          ></apexchart>
                          <apexchart
                            ref="chart4Queue"
                            type="donut"
                            :options="optionsHangUpDonut"
                            :series="serieHangUpDonut"
                            v-if="chartItem === 'Colgado'"
                          ></apexchart>
                          <apexchart
                            ref="chart5Queue"
                            type="line"
                            :options="optionsGraph5"
                            :series="serieGraph5"
                            v-if="chartItem === 'Colas'"
                          ></apexchart>
                          <apexchart
                            ref="chart6Queue"
                            type="bar"
                            :options="optionsBar2"
                            :series="serieBar2"
                            v-if="chartItem === 'Pérdidas' && render"
                          ></apexchart>
                          <apexchart
                            ref="chart7Queue"
                            type="line"
                            :options="optionsGraph7"
                            :series="serieGraph7"
                            v-if="chartItem === 'Agrupado'"
                          ></apexchart>
                          <apexchart
                            ref="chart8Queue"
                            type="donut"
                            :options="optionsFrecuencyDonut"
                            :series="serieIncomingFrecuencyDonut"
                            v-if="chartItem === 'Frecuencia'"
                          ></apexchart>
                        </v-card>

                        <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image">
                        </v-skeleton-loader>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6" class="d-none d-md-flex">
                  <!-- tabs de las graficas -->
                  <v-card outlined>
                    <v-tabs v-model="tabGraph" background-color="transparent" color="primary" grow>
                      <v-tab v-for="item in graph" :key="item">
                        {{ item }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tabGraph">
                      <v-tab-item v-for="chartItem in graph" :key="chartItem">
                        <v-card flat v-if="render">
                          <apexchart
                            ref="chart3Queue"
                            type="donut"
                            :options="optionsDonut"
                            :series="serieDonut"
                            v-if="chartItem === 'Atención'"
                          ></apexchart>

                          <apexchart
                            ref="chart2Queue"
                            type="bar"
                            :options="optionsBar"
                            :series="serieBar"
                            v-if="chartItem === 'Agentes' && render"
                          ></apexchart>

                          <apexchart
                            ref="chart1Queue"
                            type="line"
                            :options="optionsLine"
                            :series="serieLine"
                            v-if="chartItem === 'Tiempo' && render"
                          ></apexchart>
                          <apexchart
                            ref="chart4Queue"
                            type="donut"
                            :options="optionsHangUpDonut"
                            :series="serieHangUpDonut"
                            v-if="chartItem === 'Colgado'"
                          ></apexchart>
                          <apexchart
                            ref="chart5Queue"
                            type="line"
                            :options="optionsGraph5"
                            :series="serieGraph5"
                            v-if="chartItem === 'Colas'"
                          ></apexchart>
                          <apexchart
                            ref="chart6Queue"
                            type="bar"
                            :options="optionsBar2"
                            :series="serieBar2"
                            v-if="chartItem === 'Pérdidas' && render"
                          ></apexchart>
                          <apexchart
                            ref="chart7Queue"
                            type="line"
                            :options="optionsGraph7"
                            :series="serieGraph7"
                            v-if="chartItem === 'Agrupado'"
                          ></apexchart>
                          <apexchart
                            ref="chart8Queue"
                            type="donut"
                            :options="optionsFrecuencyDonut"
                            :series="serieIncomingFrecuencyDonut"
                            v-if="chartItem === 'Frecuencia'"
                          ></apexchart>
                        </v-card>

                        <v-skeleton-loader v-else transition="scale-transition" class="mx-auto" type="image">
                        </v-skeleton-loader>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <!-- </v-card-text> -->
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <!-- </v-card-text> -->
    </v-card>
  </section>
</template>

<script>
// import { mapState } from "vuex";
import moment from "moment";
import axios from "axios";
import RangeDateDialog from "../../components/DatePickers/DateRangePicker.vue";
import recordingPathGenerator from "../../components/Utils/recordingPathGenerator";
import { generateCustomApexChartTooltip } from "@/components/Utils/generateCustomApexChartTooltip";
import { PbxHttpClient } from "@/services/httpclient";
import { DATE_TYPE_BY_TAB_FORMAT, getDateObject } from "./dashboards/utils";
import { generateDonutOptions } from "@/utils/charts";

moment.locale("es");

export default {
  inject: ["theme"],

  components: {
    RangeDateDialog,
  },

  data() {
    return {
      active: false,
      isLoading: false,
      rangeDateDialog: false,
      webURL: null,
      datesRange: ["2019-09-10", "2019-09-20"],
      dialog: false,
      render: false,
      activeGraph: false,
      tab: null,
      tabGraph: null,
      tabHeaders: ["Dia", "Mes", "Año", "Personalizado"],
      tabRequestPath: ["tail_day_details", "tail_mounth_details", "tail_year_details", "tail_personality_details"],
      graph6Type: null,
      customSearchDateRange: null,
      graph: ["Atención", "Agentes", "Tiempo", "Colgado", "Colas", "Pérdidas", "Agrupado"],
      //Detail Table assets
      currentItem: {},
      detailsTable: false,
      detailsTableHeader: {
        1: [
          {
            text: "Nombre",
            value: "queue.name",
            width: "20%",
          },
          {
            text: "Cola",
            value: "qname",
            width: "30%",
          },
          {
            text: "Número",
            value: "cdr.src",
            width: "30%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "25%",
          },
          {
            text: "Acción",
            value: "action",
            width: "15%",
          },
        ],
        2: [
          {
            text: "Nombre",
            value: "queue.name",
            width: "20%",
          },
          {
            text: "Cola",
            value: "qname",
            width: "20%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "20%",
          },
          {
            text: "Agente",
            value: "agent",
            width: "20%",
          },
          {
            text: "Número",
            value: "numero",
            width: "13%",
          },
          {
            text: "Colgado",
            value: "hang",
            width: "13%",
          },
          {
            text: "Tiempo de Espera",
            value: "tiempoespera",
            width: "13%",
          },
          {
            text: "Hablado",
            value: "spoken",
            width: "13%",
          },
          {
            text: "Acción",
            value: "action",
            width: "13%",
          },
        ],
        3: [
          {
            text: "Nombre",
            value: "queue.name",
            width: "20%",
          },
          {
            text: "Numero",
            value: "qname",
            width: "15%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "20%",
          },
          {
            text: "Tiempo de Espera",
            value: "tiempoespera",
            width: "20%",
          },
          {
            text: "Número",
            value: "numero",
            width: "13%",
          },
          {
            text: "Acción",
            value: "action",
            width: "13%",
          },
        ],
        4: [
          {
            text: "Nombre",
            value: "queue.name",
            width: "20%",
          },
          {
            text: "Cola",
            value: "qname",
            width: "20%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "20%",
          },
          {
            text: "Agente",
            value: "agent",
            width: "20%",
          },
          {
            text: "Número",
            value: "numero",
            width: "13%",
          },
          {
            text: "Colgado",
            value: "hang",
            width: "13%",
          },
          {
            text: "Tiempo de Espera",
            value: "tiempoespera",
            width: "13%",
          },
          {
            text: "Hablado",
            value: "spoken",
            width: "13%",
          },
          {
            text: "Acción",
            value: "action",
            width: "13%",
          },
        ],
        5: [
          {
            text: "Nombre",
            value: "queue.name",
            width: "20%",
          },
          {
            text: "Cola",
            value: "qname",
            width: "20%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "20%",
          },
          {
            text: "Agente",
            value: "agent",
            width: "20%",
          },
          {
            text: "Número",
            value: "numero",
            width: "13%",
          },
          {
            text: "Colgado",
            value: "hang",
            width: "13%",
          },
          {
            text: "Tiempo de Espera",
            value: "tiempoespera",
            width: "13%",
          },
          {
            text: "Hablado",
            value: "spoken",
            width: "13%",
          },
          {
            text: "Acción",
            value: "action",
            width: "13%",
          },
        ],
        6: [
          {
            text: "Nombre",
            value: "queue.name",
            width: "20%",
          },
          {
            text: "Cola",
            value: "qname",
            width: "20%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "20%",
          },
          {
            text: "Agente",
            value: "agent",
            width: "20%",
          },
          {
            text: "Número",
            value: "numero",
            width: "13%",
          },
          {
            text: "Colgado",
            value: "hang",
            width: "13%",
          },
          {
            text: "Tiempo de Espera",
            value: "tiempoespera",
            width: "13%",
          },
          {
            text: "Hablado",
            value: "spoken",
            width: "13%",
          },
          {
            text: "Acción",
            value: "action",
            width: "13%",
          },
        ],
        7: [
          {
            text: "Nombre",
            value: "queue.name",
            width: "20%",
          },
          {
            text: "Cola",
            value: "qname",
            width: "30%",
          },
          {
            text: "Número destino",
            value: "csr_enterqueue.info2",
            width: "30%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "25%",
          },
          {
            text: "Acción",
            value: "action",
            width: "15%",
          },
        ],
        8: [
          {
            text: "Cola",
            value: "qname",
            width: "30%",
          },
          {
            text: "Nombre",
            value: "agent",
            width: "20%",
          },
          {
            text: "Número destino",
            value: "csr_enterqueue.info2",
            width: "30%",
          },
          {
            text: "Fecha",
            value: "fecha",
            width: "25%",
          },
          {
            text: "Acción",
            value: "action",
            width: "15%",
          },
        ],
      },
      detailsTableItems: [],
      totalDetailsItems: 0,
      detailsTableOptions: {},
      cdrDialogData: [],
      cdrDialogTableHeaders: [
        { text: "Origen", value: "src", width: "10%" },
        {
          text: "Destino",
          value: "dst",
          width: "15%",
        },
        {
          text: "Duración",
          align: "right",
          value: "duracion",
          width: "15%",
          // align: "center"
        },
        {
          text: "Hablado",
          align: "right",
          value: "hablado",
          width: "15%",
          // align: "center"
        },
        {
          text: "Estado",
          value: "estado",
          width: "15%",
        },
        {
          text: "Grabación",
          align: "center",
          value: "recordingfile",
          filterable: false,
          width: "25%",
        },
      ],
      cdrDialog: false,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      totalCalls: 100,
      // Frecuency
      totalIncomingFrecuency: 0,
      optionsFrecuencyDonut: generateDonutOptions(["Una vez", "Dos veces", "Tres veces", "4 veces", "Mas de 4 veces"]),
      serieIncomingFrecuencyDonut: [0, 0, 0, 0, 0],
      desserts: [
        { name: "Llamadas ingresadas", type: 1, total: 0 },
        { name: "Llamadas contestadas", type: 2, total: 0 },
        { name: "Llamadas abandonadas", type: 3, total: 0 },
        { name: "Llamadas Time Out", type: 4, total: 0 },
        { name: "Eficiencia en la atención", total: `0 %` },
        { name: "Promedio en espera", total: `0 seg` },
        { name: "Promedio en conversación", total: `0 seg` },
        { name: "Promedio de abandono", total: `0 seg` },
        { name: "Llamadas colgadas por el agente", type: 5, total: `0` },
        { name: "Llamadas colgadas por el usuario", type: 6, total: `0` },
        { name: "Llamada mas larga", total: `00:00:00` },
        { name: "Llamadas transferida", type: 7, total: `0` },
        { name: "Intentos no atendidos", type: 8, total: `0` },
      ],
      tooltipInfo: [
        {
          contestadas: {
            a: 0,
            b: 0,
          },
        },
        {
          abandonadas: {
            a: 0,
            b: 0,
          },
        },
      ],

      optionsDonut: {
        chart: {
          height: 350,
          type: "donut",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 350,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],

        labels: [
          "Contestadas < 20s",
          "Contestadas > 20s",
          "Abandonadas < 8s",
          "Abandonadas > 8s",
          "Timeout",
          "Transferidas",
        ],
        fill: {
          colors: ["#00E396", "#008FFB", "#FEB019", "#FF4560", "#775DD0", "#c7f464"],
        },
        colors: ["#00E396", "#008FFB", "#FEB019", "#FF4560", "#775DD0", "#c7f464"],
      },

      optionsHangUpDonut: generateDonutOptions(["% Colgado por el Agente", "% Colgado por el Usuario"]),
      optionsBar: {
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            const value = series[seriesIndex][dataPointIndex];
            const customLabel = "Promedio";
            const customValue = `${this.grap2ValuesByAgent[dataPointIndex].infosu /
              this.grap2ValuesByAgent[dataPointIndex].total} seg`;

            return generateCustomApexChartTooltip(value, customLabel, customValue);
          },
        },

        xaxis: {
          categories: [],
        },

        // fill: {
        //     colors: ["#625FA4"]
        // },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 3,
          opacity: 0.5,
        },
      },
      optionsBar2: {
        xaxis: {
          categories: [],
        },
        // fill: {
        //     colors: ["#625FA4"]
        // },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 3,
          opacity: 0.5,
        },
      },
      optionsLine: {
        xaxis: {
          categories: [],
        },
      },
      optionsGraph5: {
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: ["N/A", "N/A", "N/A", "N/A", "N/A"],
        },
      },
      optionsGraph7: {
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: ["N/A", "N/A", "N/A", "N/A", "N/A"],
        },
      },
      // serieDonut: [
      //   {
      //     // name: "Contestadas antes de 20s",
      //     name: "A",
      //     data: [44, 55, 11],
      //   },
      //   {
      //     // name: "Abandonadas antes de 8s",
      //     name: "B",
      //     data: [13, 23, 0],
      //   },
      // ],
      serieDonut: [0, 0, 0, 0, 0, 0],
      serieHangUpDonut: [0, 0],
      serieBar: [
        {
          name: "serie bar",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      serieBar2: [
        {
          name: "serie bar 2",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      serieLine: [
        {
          name: "Ingresadas",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Contestadas",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Abandonadas",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Time Out",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      serieGraph5: [
        {
          name: "Ingresadas",
          data: [0, 0, 0, 0, 0],
        },
        {
          name: "Contestadas",
          data: [0, 0, 0, 0, 0],
        },
        {
          name: "Abandonadas",
          data: [0, 0, 0, 0, 0],
        },
        {
          name: "Time Out",
          data: [0, 0, 0, 0, 0],
        },
      ],
      serieGraph7: [
        {
          name: "Ingresadas",
          data: [0, 0, 0, 0, 0],
        },
        {
          name: "Contestadas",
          data: [0, 0, 0, 0, 0],
        },
        {
          name: "Abandonadas",
          data: [0, 0, 0, 0, 0],
        },
        {
          name: "Time Out",
          data: [0, 0, 0, 0, 0],
        },
      ],

      grap2ValuesByAgent: {},
      initialLoad: true,
    };
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },

    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    dateRangeText() {
      return this.dates.join(" ~ ");
    },

    filteredTabHeaders() {
      // if (this.CurrentRole === 10) return ["Dia", "Personalizado"];
      if (this.CurrentRole === 10) return ["Personalizado"];
      return this.tabHeaders;
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },

    detailsTableOptions: {
      handler(newVal, oldVal) {
        if (this.initialLoad) {
          this.initialLoad = false;
          return;
        }
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.getCallDetails();
        }
      },
      deep: true,
    },

    detailsTable() {
      this.detailsTableOptions.page = 1;
    },

    tab(val) {
      if (val === 3) this.graph = [...this.graph, "Agrupado"];
      else this.graph = ["Atención", "Agentes", "Tiempo", "Colgado", "Colas", "Pérdidas", "Frecuencia"];
    },
  },

  created() {
    this.isLoading = true;
    if (this.CurrentRole === 10) {
      this.search("Personalizado");
      this.getQueues();
    } else {
      this.search("Dia");
    }
    this.changeThemeChart();
  },

  updated() {
    this.changeThemeChart();
  },

  methods: {
    eventdialog(value) {
      this.active = false;
      this.customSearchDateRange = value.date;

      if (value !== "cerrar") {
        this.graphics(value.response);
        if (value.date) this.getFrecuencyData(null, { start: value.date.start, end: value.date.end });
      } else {
        this.tab = 0;
        this.search("Dia");
      }
    },

    async search(format) {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      this.isLoading = true;
      // Activamos loader y ocultamos gráficas (Para búsquedas personalizadas)
      this.render = false;
      this.activeGraphDonut = false;
      this.activeGraphIncoming = false;
      this.activeGraphOutgoing = false;

      this.tabGraph = 0;
      this.customSearchDateRange = null;
      this.detailsTableItems = [];
      this.totalDetailsItems = 0;
      try {
        if (format.charAt(0) === "P") {
          // console.log("seleccione p");
          this.active = true;
        } else {
          const request = {
            format: format.charAt(0),
            value: moment().format("YYYY-MM-DD"),
          };

          let response = await this.$store.dispatch("tail/GET_REPORT", request);

          const typeOfFrecuency = DATE_TYPE_BY_TAB_FORMAT[format];

          await this.getFrecuencyData(typeOfFrecuency);

          this.render = true;
          this.webURL = response.url;
          this.graphics(response);
        }
      } catch (error) {
        // console.error(error, "error");
        this.render = true;
        // this.loading = false;
        // this.$notify({
        //   title: 'Error',
        //   message: 'cargando registros',
        //   type: 'error',
        // });
      }
      this.isLoading = false;
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },

    graphics(response) {
      this.totalCalls = response.entered;
      // primera grafica
      // this.serieDonut = [
      //   {
      //     // name: "Contestadas antes de 20s",
      //     name: "A",
      //     data: [
      //       this.tooltipInfo[0].abandonadas.a,
      //       this.tooltipInfo[0].contestadas.a,
      //       response.timeOutCall,
      //     ],
      //   },
      //   {
      //     // name: "Abandonadas antes de 8s",
      //     name: "B",
      //     data: [
      //       response.replied - response.service_level_20s,
      //       response.abandoned - response.abandoned_before_8s,
      //       0,
      //     ],
      //   },
      // ];

      this.serieDonut = [
        response.service_level_20s,
        response.replied - response.service_level_20s,
        response.abandoned_before_8s,
        response.abandoned - response.abandoned_before_8s,
        response.timeOutCall,
        response.attendedtransfer,
      ];

      // const percent1 =
      //   ((response.replied - response.service_level_20s) / response.replied) *
      //   100;
      // const percent3 =
      //   ((response.abandoned - response.abandoned_before_8s) /
      //     response.abandoned) *
      //   100;
      // const percent5 = (response.timeOutCall / response.entered) * 100;
      // const percent6 = (response.attendedtransfer / response.entered) * 100;

      // this.serieDonut = [
      //   percent1,
      //   response.average_service_level_20s,
      //   percent3,
      //   response.average_abandoned_before_8s,
      //   percent5,
      //   percent6,
      // ];

      // segunda grafica
      this.optionsBar.xaxis.categories = response.graph2.data.map(function(value) {
        return value.agent;
      });

      this.grap2ValuesByAgent = response.graph2.data.reduce((acc, el, idx) => ({ ...acc, [idx]: el }), {});
      this.serieBar[0].data = response.graph2.data.map(function(value) {
        return value.total;
      });

      // tercera grafica (Líneas)
      this.optionsLine.xaxis.categories = response.graph3H;
      this.serieLine[0].data = response.graph3C;
      this.serieLine[1].data = response.graph3A;
      this.serieLine[2].data = response.graph3B;
      this.serieLine[3].data = response.graph3T;

      // Cuarta grafica

      this.serieHangUpDonut = [response.completeAgent, response.completeUser];

      // Tabla
      // console.log(response);
      this.tooltipInfo = [
        {
          contestadas: {
            a: response.service_level_20s,
            b: response.average_service_level_20s,
          },
        },
        {
          abandonadas: {
            a: response.abandoned_before_8s,
            b: response.average_abandoned_before_8s,
          },
        },
      ];

      this.desserts = [
        {
          name: "Llamadas ingresadas",
          total: response.entered,
          type: 1,
        },
        {
          name: "Llamadas contestadas",
          total: response.replied,
          type: 2,
        },
        {
          name: "Llamadas abandonadas",
          total: response.abandoned,
          type: 3,
        },
        {
          name: "Llamadas Time Out",
          total: `${response.timeOutCall}`,
          type: 4,
        },
        {
          name: "Eficiencia en la atencion",
          total: `${response.efficiency} %`,
        },
        {
          name: "Promedio en espera",
          total: `${response.average_wait} seg`,
        },
        {
          name: "Promedio en conversacion",
          total: `${response.average_conversation} seg`,
        },
        {
          name: "Promedio de abandono",
          total: `${response.average_abandonment} seg`,
        },
        {
          name: "Llamadas colgadas por el agente",
          total: response.completeAgent || "0",
          type: 5,
        },
        {
          name: "Llamadas colgadas por el usuario",
          total: response.completeUser || "0",
          type: 6,
        },
        { name: "Llamada mas larga", total: response.max_call || "00:00:00" },
        {
          name: "Llamadas transferida",
          total: response.attendedtransfer || "0",
          type: 7,
        },
        {
          name: "Intentos no atendidos",
          total: response.ringnoAnswer || "0",
          type: 8,
        },
      ];

      // Quinta grafica
      this.optionsGraph5.xaxis.categories = response.graph5.map((el) => el.qname);
      this.serieGraph5[0].data = response.graph5.map(
        ({ CONNECT, ABANDON, EXITWITHTIMEOUT }) => Number(CONNECT) + Number(ABANDON) + Number(EXITWITHTIMEOUT),
      );
      this.serieGraph5[1].data = response.graph5.map((el) => el.CONNECT);
      this.serieGraph5[2].data = response.graph5.map((el) => el.ABANDON);
      this.serieGraph5[3].data = response.graph5.map((el) => el.EXITWITHTIMEOUT);

      // Sexta grafica
      // console.log("aquiqwq", response.graph6.data);
      this.optionsBar2.xaxis.categories = response.graph6.data.map(function(value) {
        return value.agent;
      });
      this.serieBar2[0].data = response.graph6.data.map(function(value) {
        return value.total;
      });

      // Septima grafica
      if (response.graph7) {
        if (this.customSearchDateRange.type === "hour")
          this.optionsGraph7.xaxis.categories = response.graph7.map((el) => `${el.data}:00`);
        if (this.customSearchDateRange.type === "day")
          this.optionsGraph7.xaxis.categories = response.graph7.map((el) =>
            moment()
              .weekday(el.data - 1)
              .format("dddd"),
          );

        this.serieGraph7[0].data = response.graph7.map(
          ({ CONNECT, ABANDON, EXITWITHTIMEOUT }) => Number(CONNECT) + Number(ABANDON) + Number(EXITWITHTIMEOUT),
        );
        this.serieGraph7[1].data = response.graph7.map((el) => el.CONNECT);
        this.serieGraph7[2].data = response.graph7.map((el) => el.ABANDON);
        this.serieGraph7[3].data = response.graph7.map((el) => el.EXITWITHTIMEOUT);
      }

      // Renderizamos al final la gráfica luego de pintar datos
      this.render = true;
    },

    async getFrecuencyData(date, customDate = null) {
      const params = customDate ? customDate : getDateObject(date);
      debugger;

      const { data: queueFrecuency } = await PbxHttpClient.get("/report_call_quantity", { params });

      const { incoming_frequency } = queueFrecuency;
      this.totalIncomingFrecuency = incoming_frequency.total;

      this.serieIncomingFrecuencyDonut = [
        incoming_frequency.one_time,
        incoming_frequency.two_times,
        incoming_frequency.three_times,
        incoming_frequency.four_times,
        incoming_frequency.more_than_four,
      ];
    },

    changeThemeChart() {
      // console.log(this.$refs);
      if (this.$refs.chart1Queue.length > 0) {
        if (this.isDark) {
          this.$refs.chart1Queue[0].updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart2Queue[0].updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart3Queue[0].updateOptions({ theme: { mode: "dark" } }, true);
        } else {
          this.$refs.chart1Queue[0].updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart2Queue[0].updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart3Queue[0].updateOptions({ theme: { mode: "light" } }, true);
        }
      }
    },

    openDetailDialog(item) {
      this.detailsTable = true;
      this.getCallDetails(item);
    },

    async getCallDetails(item = this.currentItem) {
      if (!item.type || !item.total) return;
      if (item.type !== this.currentItem.type) {
        this.totalDetailsItems = 0;
        this.detailsTableItems = [];
      }
      this.actualHeader = item.type;
      this.isLoading = true;
      this.currentItem = item;
      const payload = {
        type: item.type,
        value: this.customSearchDateRange,
      };
      const page = this.detailsTableOptions.page;
      const accessToken = localStorage.getItem("token");
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_ROOTAPI}/reports/${this.tabRequestPath[this.tab]}?page=${page}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );
        // console.log("response", res.data.data);
        this.totalDetailsItems = res.data.data.total;
        this.detailsTableItems = res.data.data.data;
      } catch (err) {
        console.log("err", err);
      }
      this.isLoading = false;
    },

    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get(`/users/${this.ProfileInfo.id}/assign-queues-extensions`);
        console.log("queues", data);
      } catch (error) {
        console.log("error getting the queues", error);
      }
    },

    showCDR(item) {
      this.cdrDialogData = [item.cdr];
      this.cdrDialog = true;
    },

    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },

    generateUrl(path, isMp3 = false) {
      return `http://${this.webURL}${recordingPathGenerator(path, isMp3)} `;
    },

    /**
     * [Obtener estado en español]
     * @param {string} state [Estado de la llamada]
     */
    getSpanishState(state) {
      if (state == "ANSWERED") {
        return {
          text: "Contestada",
          color: "success",
          icon: "mdi-phone-outline",
        };
      } else {
        return {
          text: "No contestada",
          color: "error",
          icon: "mdi-call-missed",
        };
      }
    },
  },
};
</script>
<style>
#detailsTable .v-data-footer__select {
  display: none;
}
</style>
